import { type BarShapeProps, Rectangle } from "recharts";

import {
  BAR_RADIUS,
  BAR_WIDTH_RATIO,
  HOVER_DIM_OPACITY,
  INSIDE_LABEL_MIN_HEIGHT,
} from "../constants";
import type { BarChartDatum } from "../types";

type Props = BarShapeProps & {
  payload?: BarChartDatum;
  hoveredIndex: number | null;
  valueFormatter: (value: number) => string;
};

export const BarShape: React.FC<Props> = ({
  x,
  y,
  width,
  height: barHeight,
  index,
  payload,
  hoveredIndex,
  valueFormatter,
}) => {
  const value = payload?.value;
  const hasValue = value != null && value > 0;
  const isDimmed = hoveredIndex != null && hoveredIndex !== index;

  const barWidth = width * BAR_WIDTH_RATIO;
  const barX = x + (width - barWidth) / 2;
  const insideBar = hasValue && barHeight > INSIDE_LABEL_MIN_HEIGHT;

  return (
    <g>
      <rect x={x} y={0} width={width} height="100%" fill="transparent" />
      {hasValue && (
        <>
          <Rectangle
            x={barX}
            y={y}
            width={barWidth}
            height={barHeight}
            radius={BAR_RADIUS}
            fill="#87874E"
            fillOpacity={isDimmed ? HOVER_DIM_OPACITY : 1}
            style={{ transition: "fill-opacity 120ms ease" }}
          />
          <text
            x={x + width / 2}
            y={insideBar ? y + barHeight - 9.9 : y - 6.6}
            textAnchor="middle"
            fontSize={12.1}
            fontWeight={600}
            fill={insideBar ? "#fff" : "#87874E"}
            opacity={isDimmed ? HOVER_DIM_OPACITY : 1}
          >
            {valueFormatter(value as number)}
          </text>
        </>
      )}
    </g>
  );
};
